export default function TableBodyHandler({
  data,
  length,
  isLoading,
}) {
  const recordCount = Array.isArray(data)
    ? data.length
    : data?.docs?.length ?? 0;

  if (isLoading && recordCount === 0) {
    return (
      <tr className="table-state-row">
        <td colSpan={length} className="table-state-cell">
          <i className="fas fa-circle-notch fa-spin table-state-spinner" />
        </td>
      </tr>
    );
  }

  if (recordCount === 0) {
    return (
      <tr className="table-state-row">
        <td colSpan={length} className="empty-table-state">
          <i className="fas fa-box-open" />
          No Records Found
        </td>
      </tr>
    );
  }

  return null;
}
